/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Invoicereceiver1Inputs */

const en__field_invoicereceiver1 = /** @type {(inputs: _Field_Invoicereceiver1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invoice to`)
};

const de__field_invoicereceiver1 = /** @type {(inputs: _Field_Invoicereceiver1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechnung an`)
};

/**
* | output |
* | --- |
* | "Invoice to" |
*
* @param {_Field_Invoicereceiver1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_invoicereceiver1 = /** @type {((inputs?: _Field_Invoicereceiver1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Invoicereceiver1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_invoicereceiver1(inputs)
	return de__field_invoicereceiver1(inputs)
});
export { _field_invoicereceiver1 as "_field_invoiceReceiver" }